import { ChangeDetectionStrategy, Component, inject, input, output, Signal } from '@angular/core';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { QuestionTypeConfig } from '../../../models/question-type-config.constants';
import { SurveyQuestionSelectionStateService } from '../../../services/survey-editor-question-selection-state.service';

@Component({
  selector: 'empathy-list-question-item',
  templateUrl: 'list-question-item.component.html',
  styleUrls: ['./list-question-item.component.scss', './_list-question-item-theme.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListQuestionItemComponent {
  active = input<boolean>();
  isFirst = input<boolean>(false);
  isLast = input<boolean>(false);
  movePositionAllowed = input<boolean>(false);
  question = input<Question>();

  activate = output<string>();

  selectedIds$: Signal<Set<string>>;
  selectMode$: Signal<boolean>;

  questionType = QuestionType;
  questionTypeConfig = QuestionTypeConfig;

  private surveyQuestionSelectionStateService = inject(SurveyQuestionSelectionStateService);

  constructor() {
    this.selectedIds$ = this.surveyQuestionSelectionStateService.getSelectedQuestionIds;
    this.selectMode$ = this.surveyQuestionSelectionStateService.getSelectedMode;
  }

  onSelectQuestion(checked: boolean): void {
    this.surveyQuestionSelectionStateService.selectQuestion(checked, this.question()?.id);
  }
}
